import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { Alert, Typography, Form, Input, Button, Col } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { authenticationService } from '../../Utilities/authenticationService';
import './login.less';

const DEFAULT_LOGIN_ERROR =
    'ユーザーIDまたはパスワードが間違っています。パスワードは半角英数字を含む、8文字以上12文字以内で入力し、半角スペースなどが含まれていないかご確認ください';

const LoginForm = ({ history, location }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const { Title } = Typography;

    if (authenticationService.currentUserValue) {
        history.push('/');
    }

    const [form] = Form.useForm();
    const [, forceUpdate] = useState(); // To disable submit button at the beginning.

    useEffect(() => {
        forceUpdate({});
    }, []);

    const onFinish = ({ username, password }) => {
        if (history.location.pathname.includes("change-password")) {
            window.localStorage.setItem('changePassword', true);
        }
        authenticationService.login(username, password).then(
            () => {
                const { from } = location.state || { from: { pathname: '/' } };
                history.push(from);
            },
            (err) => {
                setErrorMessage(typeof err === 'string' && err.trim() ? err : DEFAULT_LOGIN_ERROR);
            }
        );
    };

    return (
        <div className='login-layout'>
            <Col span={4} className='login-wrapper'>
                <Title level={4}>ログイン</Title>
                <Form form={form} name="loginform" onFinish={onFinish} initialValues={{ remember: true }}>
                    { errorMessage && <Form.Item>
                        <Alert
                            description={errorMessage}
                            type='error'
                            showIcon
                            closable
                            onClose={() => setErrorMessage(null)}
                        />
                    </Form.Item> }
                    <Form.Item
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'ユーザー名を入力してください'
                            }
                        ]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="ユーザーID" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{
                            required: true,
                            message: 'パスワードを入力してください'
                        }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="パスワード"
                        />
                    </Form.Item>
                    <Form.Item shouldUpdate>
                        { () => (
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                disabled={
                                    !form.isFieldTouched('username') || !form.isFieldTouched('password') ||
                                        form.getFieldsError().filter(({ errors }) => errors.length).length}
                            >
                                        ログイン
                            </Button>
                        )}
                    </Form.Item>
                </Form>
            </Col>
        </div>
    );
};

LoginForm.propTypes = {
    history: propTypes.object,
    location: propTypes.object
};

export default LoginForm;
